export const THEME_PACK_CATALOG = {
  hk_ai_models: {
    dataSlug: "hk-models-applications",
    market: "HK",
    shortName: "HK AI",
    displayName: "HK AI Models",
  },
  hk_ai_compute: {
    dataSlug: "hk-compute-infrastructure",
    market: "HK",
    shortName: "HK AI",
    displayName: "HK AI Compute",
  },
  hk_robotics: {
    dataSlug: "hk-robotics",
    market: "HK",
    shortName: "HK Robotics",
    displayName: "HK Robotics",
  },
  us_data_center: {
    dataSlug: "us-data-center",
    market: "US",
    shortName: "US Data Center",
    displayName: "US Data Center",
  },
  hk_ai_photonics: {
    dataSlug: "hk-ai-photonics-optical-interconnect",
    market: "HK",
    shortName: "HK AI Photonics",
    displayName: "HK AI Photonics",
  },
  us_ai_photonics: {
    dataSlug: "us-ai-photonics-optical-interconnect",
    market: "US",
    shortName: "US AI Photonics",
    displayName: "US AI Photonics",
  },
  us_robotics: {
    dataSlug: "us-robotics",
    market: "US",
    shortName: "US Robotics",
    displayName: "US Robotics",
  },
  us_nuclear: {
    dataSlug: "us-nuclear",
    market: "US",
    shortName: "US Nuclear",
    displayName: "US Nuclear",
  },
  us_oil_energy: {
    dataSlug: "us-oil-energy",
    market: "US",
    shortName: "US Oil & Energy",
    displayName: "US Oil & Energy",
  },
} as const;

export type ThemePackCampaignId = keyof typeof THEME_PACK_CATALOG;

export function getThemePackCampaign(
  raw: string | null | undefined,
): ThemePackCampaignId | null {
  const id = raw?.trim().toLowerCase();
  if (!id) {
    return null;
  }
  if (Object.hasOwn(THEME_PACK_CATALOG, id)) {
    return id as ThemePackCampaignId;
  }
  return (
    (Object.entries(THEME_PACK_CATALOG).find(
      ([, entry]) => entry.dataSlug === id,
    )?.[0] as ThemePackCampaignId | undefined) ?? null
  );
}

export function getThemePackByDataSlug(raw: string | null | undefined) {
  const slug = raw?.trim().toLowerCase();
  if (!slug) {
    return null;
  }
  return (
    Object.entries(THEME_PACK_CATALOG).find(
      ([, entry]) => entry.dataSlug === slug,
    ) ?? null
  );
}

export function resolveThemePackDataSlug(
  raw: string | null | undefined,
): string | null {
  const campaign = getThemePackCampaign(raw);
  if (campaign) {
    return THEME_PACK_CATALOG[campaign].dataSlug;
  }
  return getThemePackByDataSlug(raw)?.[1].dataSlug ?? null;
}
